import ConfigurationManager from '../config/ConfigurationManager';
import { TBX_ENVS } from '../config';

/**
 * Resuelve runtime la configuración a usar por los servicios.
 * Web: variables de entorno.
 * Apps: va por configuracion multi-entorno en app.json a través del ConfigurationManager.
 */
 export const resolveCurrentEnvironment = () => {
  const CURRENT_ENV = ConfigurationManager.currentENV || ConfigurationManager.getEnvironment(TBX_ENVS?.TBX_DEFAULT_ENVIRONMENT);

  return CURRENT_ENV || TBX_ENVS;
}

/**
 * Validate custom user agent for mobile's client
 * 
 * @return {Boolean}
 */
export const checkUserAgentCustom = () => {
  const userAgent = navigator.userAgent;
  const USER_AGENT_PREFIXES = ['tbxandroidapp', 'tbxiosapp'];
  const result = USER_AGENT_PREFIXES.some(prefix => userAgent.startsWith(prefix));

  return !!result;
};
